import Vue from 'vue'
import Router from 'vue-router'

/*
* 首页
* */
// @ 代表是在src目录下
import main from '@/pages/main'
// 首页
import index from '@/pages/main/index'
// 儿童定向
import orientMain from '@/pages/orient/main'
import orient from '@/pages/orient/index'
import oDetail from '@/pages/orient/detail/detail'
// 定向动态
import dynamicMain from '@/pages/dynamic/main'
import dynamic from '@/pages/dynamic/index'
import dDetail from '@/pages/dynamic/detail/detail'
// 活动赛事
import gameMain from '@/pages/game/main'
import game from '@/pages/game/index'
import gDetail from '@/pages/game/detail/detail'
// 教研培训
import trainMain from '@/pages/train/main'
import train from '@/pages/train/index'
import trainDetail from '@/pages/train/detail/detail'
// 定向风采
import mienMain from '@/pages/mien/main'
import mienTeacher from '@/pages/mien/teacher'
import mienSchool from '@/pages/mien/school'
import tDetail from '@/pages/mien/detail/tDetail'
import sDetail from '@/pages/mien/detail/sDetail'
// 定向装备
import equipMain from '@/pages/equip/main'
import equip from '@/pages/equip/index'
import eDetail from '@/pages/equip/detail/detail'
// 联系我们
import contact from '@/pages/contact/index'

// 下载文件
import downloadMain from '@/pages/download/main'
import downloadIndex from '@/pages/download/index'

// 第三方网站
import websiteMain from '@/pages/website/main'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      component: main,
      children: [{
        path: '/',
        component: index
      }, {
        path: 'orient',
        component: orientMain,
        children: [{
          path: '/',
          component: orient
        }, {
          path: 'detail',
          component: oDetail
        }]
      }, {
        path: 'dynamic',
        component: dynamicMain,
        children: [{
          path: '/',
          component: dynamic
        }, {
          path: 'detail',
          component: dDetail
        }]
      }, {
        path: 'game',
        component: gameMain,
        children: [{
          path: '/',
          component: game
        }, {
          path: 'detail',
          component: gDetail
        }]
      }, {
        path: 'train',
        component: trainMain,
        children: [{
          path: '/',
          component: train
        }, {
          path: 'detail',
          component: trainDetail
        }]
      }, {
        path: 'mien',
        component: mienMain,
        children: [{
          path: 'teacher',
          component: mienTeacher
        }, {
          path: 'school',
          component: mienSchool
        }, {
          path: 'tDetail',
          component: tDetail
        }, {
          path: 'sDetail',
          component: sDetail
        }]
      }, {
        path: 'equip',
        component: equipMain,
        children: [{
          path: '/',
          component: equip
        }, {
          path: 'detail',
          component: eDetail
        }]
      }, {
        path: 'contact',
        component: contact
      }, {
        path: 'download',
        component: downloadMain,
        children: [{
          path: '/',
          component: downloadIndex
        }]
      }, {
        path: 'website',
        component: websiteMain
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js